/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "491abb6bc68eff5159abafb8c25c02946c816924";
